import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export default {
  namespaced: true,
  state: {
    loadingLogs: false,
    loadingExport: false,
    filters: {
      page: 1,
      limit: 10,
      offset: 0,
      sort: 'nom',
      search: '',
      typeError: 'ERROR,WARN'
    },
    results: {
      total: -1,
      statistiques: {
        idUniq: null,
        idFlux: null,
        annonceur: 0,
        bilanAnnonces: {
          modifies: 0,
          traites: 0,
          identiques: 0,
          ajoutes: 0,
          non_valides: 0,
          produits_vendus: 0,
          integrees: 0,
          supprimes: 0
        },
        bilanPhotos: {
          issues_cache: 0,
          modifies: 0,
          non_telechargees: 0,
          traites: 0,
          identiques: 0,
          ajoutes: 0,
          non_valides: 0,
          integrees: 0,
          supprimes: 0
        },
        type: null,
        startDate: null,
        endDate: null,
        serveur: null,
        idTraitement: 0,
        idFluxPartenaire: 0,
        codeFluxPartenaire: null,
        nomFluxPartenaire: null
      },
      annonces: []
    },
    messages: null
  },
  getters: {
    getRapport: (state) => state.results,
    getEndDate: (state) => state.results.statistiques.endDate,
    getBilanAnnoncesIntegrees: (state) => state.results.statistiques.bilanAnnonces.integrees,
    getBilanAnnoncesTraitees: (state) => state.results.statistiques.bilanAnnonces.traites,
    getBilanAnnoncesSupprimes: (state) => state.results.statistiques.bilanAnnonces.supprimes,
    getFilters: (state) => state.filters,
    getPage: (state) => state.filters.page,
    getOffset: (state) => state.filters.offset,
    getLimit: (state) => state.filters.limit,
    getSort: (state) => state.filters.sort,
    getLoadingLogs: (state) => state.loadingLogs,
    getMessages: (state) => state.messages
  },
  actions: {
    loadRapportGlobalIntegration ({ commit }) {
      commit('setLoadingLogs', true)
      HTTP_HYPER_ESPACE_BACKEND.get('/rapport-global-integration')
        .then((response) => {
          commit('setResults', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          commit('setLoadingLogs', false)
        })
    },
    loadRapportGlobalIntegrationwithFilters ({ commit, state }) {
      const filters = {
        page: state.filters.page,
        perPage: state.filters.limit,
        level: state.filters.typeError,
        offset: state.filters.offset,
        search: state.filters.search
      }
      const filtersAsString = Object.fromEntries(
        Object.entries(filters).map(([key, value]) => [key, String(value)])
      )

      const params = new URLSearchParams(filtersAsString)
      commit('setLoadingLogs', true)
      HTTP_HYPER_ESPACE_BACKEND.get(`/rapport-global-integration?${params.toString()}`)
        .then((response) => {
          commit('setResults', response.data)
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          commit('setLoadingLogs', false)
        })
    },
    loadExportIntegration ({ commit }) {
      HTTP_HYPER_ESPACE_BACKEND.get('/export-rapport-integration')
        .then((response) => {
          if (response.status === 200) {
            commit('setMessages', response.data)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  mutations: {
    setLoadingLogs (state, bool) {
      state.loadingLogs = bool
    },
    setResults (state, results) {
      state.results = results
    },
    setMessages (state, messages) {
      state.messages = messages
    },
    setFilters (state, { key, value }) {
      state.filters[key] = value
    },
    setResetFilters (state) {
      state.filters.page = 1
      state.filters.limit = 10
      state.filters.sort = 'nom'
      state.filters.offset = 0
      state.filters.search = ''
      state.filters.typeError = 'ERROR,WARN'
    }
  }
}
